import React from "react";
import { Image, Button, Box, Section, Text } from "@quarkly/widgets";
import { Override } from "@quarkly/components";

const IndexesBlurb = () => (
  <>
    <Section
      padding="60px 0 60px 0"
      background="linear-gradient(0deg,rgba(0,0,0,0) 19%,--color-dark 100%),#a4a4a4 url(https://images.unsplash.com/photo-1484542603127-984f4f7d14cb?ixlib=rb-4.0.3&q=85&fm=jpg&crop=entropy&cs=srgb&w=2000) 0% 15%"
      quarkly-title="Section_Blurb1"
    >
      <Override
        slot="SectionContent"
        flex-direction="row"
        sm-flex-wrap="wrap"
      />
      <Box
        empty-border-width="1px"
        empty-border-style="solid"
        empty-border-color="LightGray"
        width="50%"
        display="flex"
        sm-width="100%"
        empty-min-width="64px"
        empty-min-height="64px"
      >
        <Image
          min-width="600px"
          src="https://images.unsplash.com/photo-1452179535021-368bb0edc3a8?ixlib=rb-4.0.3&q=85&fm=jpg&crop=entropy&cs=srgb&w=2000"
          max-height="600px"
          object-fit="cover"
          lg-max-height="350px"
          lg-max-width="100%"
          width="100%"
          lg-width="100%"
          lg-min-width="350px"
          srcSet="https://images.unsplash.com/photo-1452179535021-368bb0edc3a8?ixlib=rb-4.0.3&q=85&fm=jpg&crop=entropy&cs=srgb&w=500 500w,https://images.unsplash.com/photo-1452179535021-368bb0edc3a8?ixlib=rb-4.0.3&q=85&fm=jpg&crop=entropy&cs=srgb&w=800 800w,https://images.unsplash.com/photo-1452179535021-368bb0edc3a8?ixlib=rb-4.0.3&q=85&fm=jpg&crop=entropy&cs=srgb&w=1080 1080w,https://images.unsplash.com/photo-1452179535021-368bb0edc3a8?ixlib=rb-4.0.3&q=85&fm=jpg&crop=entropy&cs=srgb&w=1600 1600w,https://images.unsplash.com/photo-1452179535021-368bb0edc3a8?ixlib=rb-4.0.3&q=85&fm=jpg&crop=entropy&cs=srgb&w=2000 2000w,https://images.unsplash.com/photo-1452179535021-368bb0edc3a8?ixlib=rb-4.0.3&q=85&fm=jpg&crop=entropy&cs=srgb&w=2600 2600w,https://images.unsplash.com/photo-1452179535021-368bb0edc3a8?ixlib=rb-4.0.3&q=85&fm=jpg&crop=entropy&cs=srgb&w=3200 3200w"
          sizes="(max-width: 576px) 100vw,(max-width: 768px) 100vw,(max-width: 992px) 100vw,100vw"
        />
      </Box>
      <Box
        empty-min-height="64px"
        empty-border-width="1px"
        width="50%"
        background="linear-gradient(180deg,#3ebe3e 77.6%,transparent 100%) 0 0 no-repeat"
        display="flex"
        flex-direction="column"
        lg-padding="24px 24px 24px 24px"
        empty-border-color="LightGray"
        align-items="center"
        justify-content="center"
        empty-min-width="64px"
        empty-border-style="solid"
        padding="86px 86px 86px 86px"
        sm-width="100%"
        border-radius="0px"
      >
        <Text
          margin="0px 0px 32px 0px"
          color="--light"
          font="--headline4"
          lg-font="700 22px/1.2 --fontFamily-googleAlegreyaSans, sans-serif"
          lg-margin="0px 0px 16px 0px"
        >
          Build renewable and sustainable projects
        </Text>
        <Text
          margin="0px 0px 0px 0px"
          color="--light"
          font="--base"
          text-align="left"
          lg-font='normal 400 16px/1.5 "Varta", sans-serif'
        >
          Our club specifically engages in engineering project development
          around the realm of:
          <br />
          - renewable energy systems,
          <br />
          - sustainability concepts,
          <br />- any auxiliary systems that support the above.
        </Text>
      </Box>
    </Section>
    <Section
      padding="60px 0 60px 0"
      background="linear-gradient(0deg,--color-dark 0%,rgba(0,0,0,0) 0%),#a4a4a4 url(https://images.unsplash.com/photo-1622050956578-94fd044a0ada?ixlib=rb-4.0.3&q=85&fm=jpg&crop=entropy&cs=srgb&w=2000) 0% 70%/cover"
      quarkly-title="Section_Blurb2"
    >
      <Override
        slot="SectionContent"
        flex-direction="row"
        sm-flex-wrap="wrap"
      />
      <Box
        empty-min-height="64px"
        empty-border-width="1px"
        width="50%"
        background="linear-gradient(180deg,rgba(0,0,0,0) 0%,#3ebe3e 13.8%,#3ebe3e 84.3%,rgba(0,0,0,0) 100%) 0 0 no-repeat"
        display="flex"
        flex-direction="column"
        lg-padding="24px 24px 24px 24px"
        empty-border-color="LightGray"
        align-items="center"
        justify-content="center"
        empty-min-width="64px"
        empty-border-style="solid"
        padding="86px 86px 86px 86px"
        sm-width="100%"
        border-radius="0px"
      >
        <Text
          margin="0px 0px 32px 0px"
          color="--light"
          font="--headline4"
          lg-font="700 22px/1.2 --fontFamily-googleAlegreyaSans, sans-serif"
          lg-margin="0px 0px 16px 0px"
        >
          Socialize and work in an organization
        </Text>
        <Text
          margin="0px 0px 0px 0px"
          color="--light"
          font="--base"
          text-align="left"
          lg-font='normal 400 16px/1.5 "Varta", sans-serif'
        >
          Our club, like other UAlberta clubs, fosters an environment where
          students can:
          <br />
          - network and socialize with others,
          <br />
          - gain insight into the management of an organization,
          <br />
          - build upon soft/teamwork skills,
          <br />- build upon technical engineering skills.
        </Text>
      </Box>
      <Box
        empty-border-width="1px"
        empty-border-style="solid"
        empty-border-color="LightGray"
        width="50%"
        display="flex"
        sm-width="100%"
        empty-min-width="64px"
        empty-min-height="64px"
      >
        <Image
          min-width="600px"
          src="https://images.unsplash.com/photo-1522071820081-009f0129c71c?ixlib=rb-4.0.3&q=85&fm=jpg&crop=entropy&cs=srgb&w=2000"
          max-height="600px"
          object-fit="cover"
          lg-max-height="350px"
          lg-max-width="100%"
          width="100%"
          lg-width="100%"
          lg-min-width="350px"
          srcSet="https://images.unsplash.com/photo-1522071820081-009f0129c71c?ixlib=rb-4.0.3&q=85&fm=jpg&crop=entropy&cs=srgb&w=500 500w,https://images.unsplash.com/photo-1522071820081-009f0129c71c?ixlib=rb-4.0.3&q=85&fm=jpg&crop=entropy&cs=srgb&w=800 800w,https://images.unsplash.com/photo-1522071820081-009f0129c71c?ixlib=rb-4.0.3&q=85&fm=jpg&crop=entropy&cs=srgb&w=1080 1080w,https://images.unsplash.com/photo-1522071820081-009f0129c71c?ixlib=rb-4.0.3&q=85&fm=jpg&crop=entropy&cs=srgb&w=1600 1600w,https://images.unsplash.com/photo-1522071820081-009f0129c71c?ixlib=rb-4.0.3&q=85&fm=jpg&crop=entropy&cs=srgb&w=2000 2000w,https://images.unsplash.com/photo-1522071820081-009f0129c71c?ixlib=rb-4.0.3&q=85&fm=jpg&crop=entropy&cs=srgb&w=2600 2600w,https://images.unsplash.com/photo-1522071820081-009f0129c71c?ixlib=rb-4.0.3&q=85&fm=jpg&crop=entropy&cs=srgb&w=3200 3200w"
          sizes="(max-width: 576px) 100vw,(max-width: 768px) 100vw,(max-width: 992px) 100vw,100vw"
        />
      </Box>
    </Section>
    <Section
      padding="60px 0 60px 0"
      background="linear-gradient(0deg,--color-dark 0%,rgba(0,0,0,0) 50%),#a4a4a4 url(https://images.unsplash.com/photo-1497435334941-8c899ee9e8e9?ixlib=rb-4.0.3&q=85&fm=jpg&crop=entropy&cs=srgb&w=2000) 0% 70%/cover"
      quarkly-title="Section_Blurb3"
    >
      <Override
        slot="SectionContent"
        flex-direction="row"
        sm-flex-wrap="wrap"
        background="rgba(0, 0, 0, 0) url() 0% 0% /auto repeat scroll padding-box"
      />
      <Box
        empty-border-width="1px"
        empty-border-style="solid"
        empty-border-color="LightGray"
        width="50%"
        display="flex"
        sm-width="100%"
        empty-min-width="64px"
        empty-min-height="64px"
      >
        <Image
          min-width="600px"
          src="https://images.unsplash.com/photo-1722649046363-bd8260b00276?ixlib=rb-4.0.3&q=85&fm=jpg&crop=entropy&cs=srgb&w=2000"
          max-height="600px"
          object-fit="cover"
          lg-max-height="350px"
          lg-max-width="100%"
          width="100%"
          lg-width="100%"
          lg-min-width="350px"
          srcSet="https://images.unsplash.com/photo-1722649046363-bd8260b00276?ixlib=rb-4.0.3&q=85&fm=jpg&crop=entropy&cs=srgb&w=500 500w,https://images.unsplash.com/photo-1722649046363-bd8260b00276?ixlib=rb-4.0.3&q=85&fm=jpg&crop=entropy&cs=srgb&w=800 800w,https://images.unsplash.com/photo-1722649046363-bd8260b00276?ixlib=rb-4.0.3&q=85&fm=jpg&crop=entropy&cs=srgb&w=1080 1080w,https://images.unsplash.com/photo-1722649046363-bd8260b00276?ixlib=rb-4.0.3&q=85&fm=jpg&crop=entropy&cs=srgb&w=1600 1600w,https://images.unsplash.com/photo-1722649046363-bd8260b00276?ixlib=rb-4.0.3&q=85&fm=jpg&crop=entropy&cs=srgb&w=2000 2000w,https://images.unsplash.com/photo-1722649046363-bd8260b00276?ixlib=rb-4.0.3&q=85&fm=jpg&crop=entropy&cs=srgb&w=2600 2600w,https://images.unsplash.com/photo-1722649046363-bd8260b00276?ixlib=rb-4.0.3&q=85&fm=jpg&crop=entropy&cs=srgb&w=3200 3200w"
          sizes="(max-width: 576px) 100vw,(max-width: 768px) 100vw,(max-width: 992px) 100vw,100vw"
        />
      </Box>
      <Box
        empty-min-height="64px"
        empty-border-width="1px"
        width="50%"
        background="linear-gradient(180deg,rgba(0,0,0,0) 0%,#3ebe3e 26.2%) 0 0 no-repeat"
        display="flex"
        flex-direction="column"
        lg-padding="24px 24px 24px 24px"
        empty-border-color="LightGray"
        align-items="center"
        justify-content="center"
        empty-min-width="64px"
        empty-border-style="solid"
        padding="86px 86px 86px 86px"
        sm-width="100%"
        border-radius="0px"
      >
        <Text
          margin="0px 0px 32px 0px"
          color="--light"
          font="--headline4"
          lg-font="700 22px/1.2 --fontFamily-googleAlegreyaSans, sans-serif"
          lg-margin="0px 0px 16px 0px"
        >
          A club to feed my sustainable mind...
          <br />a club to build my professionalism.
        </Text>
        <Text
          margin="0px 0px 0px 0px"
          color="--light"
          font="--base"
          text-align="left"
          lg-font='normal 400 16px/1.5 "Varta", sans-serif'
        >
          If you are a student or alumni of University of Alberta, feel free to
          join! Currently, our club style is to build at a self motivated pace
          (as we understand that school is our primary focus, so club activity
          is secondary).
          <br />
          {"  "}
          <br />
        </Text>
        <Button
          color="--light"
          padding="12px 36px 12px 36px"
          background="linear-gradient(180deg,--color-dark 100%,transparent 100%) 0 0 no-repeat"
          border-radius="32px"
          type="link"
          width="100%"
          display="block"
          flex="0 0 auto"
          align-self="center"
          order="0"
          hover-background="linear-gradient(180deg,#e51fec 63.8%,#1e1616 100%) 0 0 no-repeat"
          text-decoration-line="initial"
          href="https://alberta.campuslabs.ca/engage/organization/red"
          target="_blank"
          text-align="center"
        >
          Join our club on Bearsden
        </Button>
      </Box>
    </Section>
  </>
);

export default IndexesBlurb;
